export const SPECIAL_FILTRATION_ITEM_PARAMS = [
  'special_offer',
  'special_offer_type',
]

export enum FILTRATION_ITEM_PARAMS {
  expert_tip = 'expert_tip',
}
